import { WordChoosen } from "../../../../context/interfaces/IAdministratorTachContext";
import ModalReportStyles from "../../../../styles/pages/Summaries/ModalReportStyles";

const { StyledModalTitle } = ModalReportStyles;

interface IHeader {
    word: WordChoosen;
}

const HeaderSelectDataTach: React.FC<IHeader> = ({ word }) => {
    const getTitle = (title: WordChoosen) => {
        const dialogTitle = {
            campus: "Selecione o(s) Campus",
            course: "Selecione o(s) Curso(s)",
            school: "Selecione a(s) Escola(s)",
            modality: "Selecione a(s) Modalidade(s)",
            professor: "Selecione o(s) Professor(es)",
        };
        return dialogTitle[title];
    };

    return <StyledModalTitle>{getTitle(word)}</StyledModalTitle>;
};

export default HeaderSelectDataTach;
